export default __webpack_public_path__ + "static/media/loading.1898eb48.png";